import { DatasetFileType } from "../models/BdaDataset";
import { DatabaseDatasource, Datasource, MessageBrokerDatasource, ObjectStorageDatasource } from "../models/Datasource";
import client from "./axios";

const vizUrl = `${window.__env.GATEWAY_URL}/v1/data-exploration`;

export const VizClient = {
  getDatabases: (body: QueryDetails, params?: URLSearchParams) => {
    if (body.type === 'objectStorage') return client.post<string[]>(`${vizUrl}/minio/buckets`, body, { params });
    return client.post<string[]>(`${vizUrl}/sql/schemas`, body, { params });
  },
  getTables: (body: QueryDetails, params?: URLSearchParams) => client.post<string[]>(`${vizUrl}/${getDatasourceType(body)}/tables`, body, { params }),
  getColumns: (body: QueryDetails, params?: URLSearchParams) => client.post<string[]>(`${vizUrl}/${getDatasourceType(body)}/columns`, body, { params }),
  getDatasetPreview: (body: QueryDetails) => client.post<any[]>(`${vizUrl}/${getDatasourceType(body)}/preview`, body),
  browseDirectories: (body: QueryDetails) => client.post(`${vizUrl}/minio/browse`, body),
  getTopics: (body: QueryDetails, params?: URLSearchParams) => client.post<string[]>(`${vizUrl}/kafka/topics`, body, { params }),
  uploadFile: (formData: FormData) => client.post(`${vizUrl}/minio/webupload`, formData),
  downloadFile: (body: QueryDetails) => client.post(`${vizUrl}/minio/download`, body, { responseType: 'blob' }),
}

function getDatasourceType(datasource: QueryDetails) {
  return datasource.type === "database" ? "sql" : datasource.driverType;
}

export class QueryDetails {
  host: string;
  port: number;
  driverType: string;
  type: Datasource['type'];
  username?: string;
  password?: string;
  database?: string;
  tableName?: string;
  // 'messageBroker' datasource
  brokers?: string;
  topic?: string;
  // 'objectStorage' datasource
  accessKey?: string;
  secretKey?: string;
  bucket?: string;
  secure?: boolean;
  prefixPath?: string;
  path?: string;
  regionName?: string;

  constructor(datasource?: Datasource, datasetFileType?: DatasetFileType) {
    this.host = datasource?.host || "";
    this.port = datasource?.port || 80;
    this.driverType = datasource?.driverType || "minio";
    this.type = datasource?.type || "objectStorage";

    if (datasource?.type === "database") {
      this.username = (datasource as DatabaseDatasource).user;
      this.password = (datasource as DatabaseDatasource).password;
      this.database = (datasource as DatabaseDatasource).database;
      this.tableName = datasetFileType?.tableName;
    }
    else if (datasource?.type === "messageBroker") {
      this.brokers = (datasource as MessageBrokerDatasource).brokers;
      this.topic = datasetFileType?.tableName;
    }
    else if (datasource?.type === "objectStorage") {
      this.accessKey = (datasource as ObjectStorageDatasource).accessKey;
      this.secretKey = (datasource as ObjectStorageDatasource).secretKey;
      this.bucket = (datasource as ObjectStorageDatasource).bucket;
      this.secure = (datasource as ObjectStorageDatasource).secure || false;
      this.prefixPath = (datasource as ObjectStorageDatasource).prefixPath;
      this.regionName = (datasource as ObjectStorageDatasource).regionName;
      this.path = datasetFileType?.tableName || datasetFileType?.path;
    }
  }
}